export default "__VITE_ASSET__DHgJOjaA__"